import * as React from "react";
import { Row, Input, Col } from "antd";
import { TPaymentInstructionPresentationModel } from "../../../presenter/payment/model/PaymentInstructionPresentationModel";
import Text from "antd/lib/typography/Text";
import TextArea from "antd/lib/input/TextArea";

const DomesticInstructionForm = ({
  translate,
  paymentInstruction
}: {
  translate: any;
  paymentInstruction?: TPaymentInstructionPresentationModel;
}) => {
  return (
    <React.Fragment>
      <Row className={"modified-wrapper"}>
        <Col lg={15} sm={24} xs={24}>
          <div className="content-container">
            <div className="content-section content-section-border">
              <Row>
                <Text className={"content-section-title"}>
                  {translate("payment_instruction_page.domestic")}
                </Text>
              </Row>
              <Row className={"group-items"}>
                <Text className={"label"}>
                  {translate("payment_instruction_page.receiver")}
                </Text>
                <TextArea
                  rows={3}
                  readOnly
                  className={"input"}
                  value={paymentInstruction?.domestic?.receiver}
                />
              </Row>
              <Row className={"group-items"}>
                <Text className={"label"}>
                  {translate("payment_instruction_page.account_number")}
                </Text>
                <Input
                  readOnly
                  className={"input"}
                  value={paymentInstruction?.domestic?.accountNumber}
                />
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default DomesticInstructionForm;
